module.exports = __webpack_public_path__ + "static/img/cat.f885f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cat.png
// module id = aTsD
// module chunks = 1